import Vue from 'vue'
import Vuex from 'vuex'
import socketio from 'socket.io-client'
import ioreq from 'socket.io-request'
import { fire } from '@/bus'

Vue.use(Vuex)

const PORT = 3033
// const IS_PROD = true
const IS_PROD = process.env.NODE_ENV === 'production'
const SIO_PROD_SERVER = 'https://backoffice.cdsvyatka.com'
const SIO_DEV_SERVER = `http://${window.location.hostname}:${PORT}`
// eslint-disable-next-line
const UPLOAD_PREFIX = IS_PROD
  ? 'https://backoffice.cdsvyatka.com/sio/backoffice/uploads'
  : '/uploads/'
// eslint-disable-next-line
const REPORTS_PREFIX = IS_PROD
  ? 'https://backoffice.cdsvyatka.com/sio/backoffice/reports'
  : '/reports/'
const SIO_SERVER = IS_PROD ? SIO_PROD_SERVER : SIO_DEV_SERVER
const DOMAIN = IS_PROD ? SIO_PROD_SERVER : `http://${window.location.hostname}:${window.location.port}`
const scope = 'backoffice'

let subs = {}
let snackid = 1
let router = null
let tokenUpdates = null

function ts () {
  return (new Date()).getTime()
}

let confirmTo = null
let confirmResolve = null
let confirmReject = null

const state = {
  domain: DOMAIN,
  socket: null,
  connected: false,
  ready: false,
  profile: null,
  group: null,
  route: null,
  snack: null,
  tasksInAction: 0,
  memorized: [],
  search: '',
  confirmMessage: null,
}
const mutations = {
  // NAVIGATION WATCHER
  NAVIGATE: (state, route) => {
    state.route = route
  },
  // SNACKS
  SNACK_SET: (state, { level, msg }) => {
    snackid++
    state.snack = {
      level, snackid, msg
    }
    console.log(level, snackid, msg)
  },
  SNACK_CLEAR: (state, snack) => {
    if (state.snack.snackid === snack.snackid) {
      state.snack = null
    }
  },
  // CONNECTION
  SOCKET: (state, socket) => {
    state.socket = socket
  },
  SOCKET_CONNECTED: (state) => {
    console.log('socket-io: connected')
    state.connected = true
  },
  SOCKET_DISCONNECTED: (state) => {
    console.log('socket-io: disconnected')
    state.connected = false
  },
  AUTH_SUCCESS: (state, profile) => {
    state.profile = profile
    state.ready = true
  },
  AUTH_LOGOUT: (state, profile) => {
    state.profile = null
  },
  AUTH_FAIL: (state) => {
    state.ready = true
  },
  SHURSHIM: (state) => {
    state.tasksInAction++
  },
  POSHURSHALY: (state) => {
    state.tasksInAction--
  },
  MEMORIZE: (state, person) => {
    state.memorized = [
      ...state.memorized.filter(x => x.personid !== person.personid),
      person
    ]
  },
  FORGET: (state, person) => {
    state.memorized = [
      ...state.memorized.filter(x => x.personid !== person.personid)
    ]
  },
  SEARCH: (state, search) => {
    router.push({ name: 'persons' })
    state.search = search
  },
  CONFIRM_CLOSE: (state) => {
    if (confirmTo) clearTimeout(confirmTo)
    confirmResolve = null
    confirmReject = null
    state.confirmMessage = null
  },
  CONFIRM_ASK: (state, message) => {
    state.confirmMessage = message
  },
}
const actions = {
  // NAVIGATION WATCHER
  navigate ({ commit, dispatch }, route) {
    commit('NAVIGATE', route)
  },
  // SNACKS
  async snack ({ commit, dispatch }, snack) {
    if (snack instanceof Error) {
      commit('SNACK_SET', {
        msg: snack.toString() + (snack.stackhash ? ` <nobr>КОД ОШИБКИ <b>${snack.stackhash}</b></nobr>` : ``),
        level: 'error'
      })
    } else if (snack.level) {
      commit('SNACK_SET', { msg: snack.msg, level: snack.level })
    } else if (snack.msg) {
      commit('SNACK_SET', { msg: snack.msg, level: 'info' })
    } else {
      commit('SNACK_SET', { msg: snack, level: 'info' })
    }
  },
  async snackClear ({ commit, dispatch }, msg) {
    commit('SNACK_CLEAR')
  },
  // CONNECTION
  async connect ({ commit, dispatch }, opts) {
    if (opts) router = opts.router
    console.log(`socket-io: connecting ${SIO_SERVER}`)
    let socket = socketio(SIO_SERVER, IS_PROD
      ? { path: '/sio/backoffice', transports: ['websocket'] }
      : { transports: ['websocket'] }
    )
    const ioreqImpl = ioreq(socket, { event: 'socket.io-request', timeout: 35000 })
    socket['request'] = ioreqImpl.request.bind(ioreqImpl)
    socket['response'] = ioreqImpl.response.bind(ioreqImpl)
    socket.on('connect', async () => {
      commit('SOCKET_CONNECTED')
      commit('SOCKET', socket)
      dispatch('loginByToken')
    })
    socket.on('disconnect', () => {
      commit('SOCKET_DISCONNECTED')
      socket.disconnect()
      dispatch('connect')
    })
    socket.on('joined', pl => console.log('joined', pl))
    // socket.on('added-on', pl => console.log('+on', pl))
    // socket.on('added-response', pl => console.log('+response', pl))
    socket.on('err', err => dispatch('snack', err))
    socket.on('profile', pl => commit('AUTH_SUCCESS', pl))
    socket.on('token', pl => {
      localStorage.setItem('backofficeToken', pl)
      if (tokenUpdates) clearTimeout(tokenUpdates)
      // обновление токена раз в час
      tokenUpdates = setTimeout(async () => {
        try {
          await dispatch('loginByToken')
        } catch (err) {
          console.log(err)
        }
      }, 60 * 60 * 1000)
    })
    socket.on('event-ac-controllers-connected', pl => fire(
      'event-ac-controllers-connected', pl
    ))
    socket.on('event-ac-controllers-disconnected', pl => fire(
      'event-ac-controllers-disconnected', pl
    ))
    commit('SOCKET', socket)
  },
  // API
  async login ({ commit, dispatch }, login) {
    try {
      login.scope = scope
      const { profile, meta } = await state.socket.request('auth-login', login)
      if (profile) {
        const message = `Выполнен вход: ${meta.as}`
        commit('AUTH_SUCCESS', profile)
        dispatch('snack', message)
        router.push({ path: 'persons' })
      } else {
        commit('AUTH_FAIL')
        console.log('Вход не удался')
      }
    } catch (err) {
      dispatch('snack', err)
    }
  },
  async logout ({ commit, dispatch }) {
    commit('AUTH_LOGOUT', null)
    localStorage.removeItem('backofficeToken')
    state.socket.emit('auth-logout')
    console.log('Выполнен выход')
    router.push({ name: 'login' })
    if (tokenUpdates) clearTimeout(tokenUpdates)
  },
  async loginByToken ({ commit, dispatch }) {
    const token = localStorage.getItem('backofficeToken')
    if (token) {
      try {
        const { profile, meta } = await state.socket.request('auth-login', { token, scope })
        if (profile) {
          const message = `Выполнен вход: ${meta.as}`
          commit('AUTH_SUCCESS', profile)
          dispatch('snack', message)
          if (router.history.current.name === 'Login') router.push({ path: 'persons' })
        } else {
          commit('AUTH_FAIL')
          router.push({ name: 'login' })
          console.log('Вход не удался')
        }
      } catch (err) {
        // случай когда проблемы с сервером и токен удалять не нужно
        if (
          err.toString().startsWith('TimeoutError') ||
          err.toString().startsWith('SocketIOError')
        ) {
          if (tokenUpdates) clearTimeout(tokenUpdates)
          tokenUpdates = setTimeout(() => {
            dispatch('loginByToken')
          }, 5000)
          throw err
        }
        // случай когда сервер не принял токен
        localStorage.removeItem('backofficeToken')
        router.push({ name: 'login' })
        dispatch('snack', err)
        commit('AUTH_FAIL')
      }
    } else {
      commit('AUTH_FAIL')
    }
    if (!state.profile) {
      const routes = router.options.routes.reduce(
        (r, x) => {
          r[x.name] = x
          return r
        }, {}
      )
      const currentRoute = routes[state.route.name]
      if (currentRoute && currentRoute.needAuth === true) {
        console.log('authorized only')
        router.push({ path: 'login' })
      }
    }
  },
  async updateToken ({ commit, dispatch }) {
    dispatch('loginByToken')
  },
  async sioEmit ({ commit, dispatch }, { topic, pl }) {
    // console.log('emit', topic)
    state.socket.emit(topic, pl)
  },
  sioOn ({ commit, dispatch }, { topic, cb }) {
    // console.log('sub', topic)
    if (subs[topic]) {
      state.socket.removeAllListeners(topic)
    }
    const sub = state.socket.on(topic, cb)
    subs[topic] = sub
    return sub
    // return state.socket.on(topic, cb)
  },
  sioUnsub ({ commit, dispatch }, { topic }) {
    // console.log('unsub', topic)
    return state.socket.removeAllListeners(topic)
  },
  getSocket () {
    return state.socket
  },
  async sioRequest ({ commit, dispatch }, { topic, pl }) {
    if (!state.connected) throw new Error('Нет связи с сервером. Проверьте подключение')
    const started = ts()
    commit('SHURSHIM')
    try {
      const data = await state.socket.request(topic, pl)
      console.log('OK', ts() - started, 'ms', topic, data.meta)
      return data
    } catch (err) {
      console.log(err.toString(), err.stackhash)
      console.log('FAILED', ts() - started, 'ms', topic, err.stackhash)
      if (err.toString().startsWith('TimeoutError')) throw new Error('Ошибка связи')
      throw err
    } finally {
      commit('POSHURSHALY')
    }
  },
  memorize ({ commit, dispatch }, person) {
    commit('MEMORIZE', person)
  },
  forget ({ commit, dispatch }, person) {
    commit('FORGET', person)
  },
  search ({ commit, dispatch }, search) {
    commit('SEARCH', search)
  },
  async confirm ({ commit, dispatch }, message) {
    commit('CONFIRM_ASK', message)
    return new Promise((resolve, reject) => {
      confirmResolve = resolve
      confirmReject = reject
      confirmTo = setTimeout(() => {
        reject(new Error('Время подтверждения истекло (30 c)'))
        commit('CONFIRM_CLOSE')
      }, 30000)
    })
  },
  confirmConfirm ({ commit, dispatch }, message) {
    confirmResolve()
    commit('CONFIRM_CLOSE')
  },
  confirmReject ({ commit, dispatch }, message) {
    confirmReject(new Error('действие прервано'))
    commit('CONFIRM_CLOSE')
  },
}

export default new Vuex.Store({
  state, actions, mutations
})
